import { Loader2 } from "lucide-react";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { dayjs } from "@/core/utils/date";
import { cn } from "@/core/utils/utils";
import type { IAiScriptExplanationChatThread } from "@/payroll/ai-script/types";

interface ChatThreadListItemProps {
  thread: IAiScriptExplanationChatThread;
  isRunning: boolean;
  onOpen: (threadId: string) => void;
}

export const ChatThreadListItem = ({
  thread,
  isRunning,
  onOpen,
}: ChatThreadListItemProps) => (
  <button
    type="button"
    onClick={() => onOpen(thread.id)}
    className={cn(
      "w-full rounded-md border border-stroke-secondary bg-background px-3 py-2.5 text-left transition-colors hover:bg-surface-secondary",
      {
        "border-primary/40 bg-primary/5": isRunning,
      },
    )}
  >
    <Stack direction="row" align="start" gap="sm" fullWidth>
      {isRunning && (
        <Loader2 className="mt-0.5 h-4 w-4 shrink-0 animate-spin text-primary" />
      )}
      <Stack gap="none" className="min-w-0 flex-1">
        <Typography variant="bodyW2" className="truncate">
          {thread.name}
        </Typography>
        <Typography variant="captionW1" textColor="tertiary">
          {isRunning
            ? "Running"
            : thread.last_message_at
              ? dayjs(thread.last_message_at).fromNow()
              : "No messages yet"}
        </Typography>
      </Stack>
    </Stack>
  </button>
);
